<template>
    <div class="table">
        <div v-for="(item,index) in newList" :key="index">
            <div :class="{tableCheck:obj.isCheck}" v-for="obj in item" :key="obj.Id" @click="changeStore(obj)">
                <img :src="obj.HeadImage">
                <div class="keepname"></div>
                <div class="classname">{{obj.StoreName}}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            newList:[],
        }
    },
    props:{
        List:{
            type: Array,
            default: function () {
                return [];
            }
        },
    },
    computed:{
    },
    components:{
    },
    created(){
    },
    methods:{
        changeStore(obj){
            this.newList.forEach((item,i)=>{
                item.forEach((items,j)=>{
                    this.$set(this.newList[i][j],'isCheck',(items.StoreId===obj.StoreId))
                })
            })
            this.$emit('update:store', obj);
        }
    },
    watch:{
        List:{
            handler(newVal,oldval) {
                // 每4个放一行
                if(newVal.length){
                    let newList = [];
                    for (let i = 0; i < newVal.length; i += 4) {
                        newList.push(newVal.slice(i, i + 4));
                    }
                    this.newList = newList;
                }
            },
            immediate: true,
        }
    },
}
</script>

<style lang="scss" scoped>
.table{
    width: 100%;
    font-size: 12px;
    display: flex;
    flex-direction:column;
    padding: 0px 40px 0px 60px;
    >div{
        display: flex;
        // justify-content:space-between;
        text-align: center;
        >div{
            width: 23%;
            height: 1.9rem;
            background-color: #ffffff;
            margin-bottom: 0.2rem;
            margin-right: 2.6%;
            border-radius: 0.26rem;
            position: relative;
            overflow: hidden;
            cursor: pointer;
            img{
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
            .classname{
                position: absolute;
                width: 100%;
                bottom: 0;
                left: 50%;
                transform: translateX(-50%);
                font-size: 0.18rem;
                color: #B176C5;
                padding: 0.04rem 0;
                background-color: #333333;
		        opacity: 0.8;
            }
        }
        >div:last-child{
            margin-right: 0px;
        }
        >div:hover{
            .classname{
                color: #ffffff;
                background-color: #B176C5;
            }
        }
        // 点击样式
        .tableCheck{
            // 遮罩层
            .keepname{
                position: absolute;
                top: 0;
                width: 100%;
                height: 100%;
                background-color: #333333;
                opacity: 0.4;
            }
            .classname{
                width: 100%;
                height: 100%;
                font-size: 0.24rem;
                font-weight: 600;
                color: #ffffff;
                background-color: transparent;
                opacity: 1;
                line-height: 1.9rem;
            }
        }
        .tableCheck:hover{
            .classname{
                background-color: transparent;
            }
        }
    }
}
@media (max-width: 768px){
    .table{
        padding: 0px 10px;
        >div{
            display: flex;
            flex-direction:column;
            text-align: center;
            >div{
                width: 100%;
                height: 7.2rem;
                margin-bottom: 0.6rem;
                margin-right: 0px;
                border-radius: 20px;
                .classname{
                    font-size: 0.6rem;
                    padding: 4px 0;
                }
            }
            >div:hover{
                .classname{
                    color: #ffffff;
                    background-color: #B176C5;
                }
            }
            .tableCheck{
                .classname{
                    font-size: 1rem;
                    line-height: 7.2rem;
                }
            }
        }
    }
}
</style>